export class AppConfig {
  readonly apiScope: string;
  readonly backendUrl: string;
  readonly validateAuthority: string;
  readonly aiConnectionString: string;
  readonly signalRHub: string;
  readonly msal_clientID: string;
  readonly msal_authority: string;
  readonly msal_redirectUri: string;
  readonly msal_postLogoutRedirectUri: string;
  readonly msal_protectedResource: string;
  readonly msal_token_scope: string;
  readonly production_environment: boolean;
  readonly dayPilot: DayPilot;
  readonly release: ReleaseInfo;
  readonly signalRLogging: boolean;

}

export class ReleaseInfo {
  readonly version: string;
  readonly environment: string;
}

export class DayPilot {
  readonly hoursBeforeNowToGetEventsFrom: number;
  readonly durationOfEventsInMinutes: number;
}
